const e = {
  name: "Mail",
  dimensions: { width: 24, height: 18 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V15C24 16.6569 22.6569 18 21 18H3C1.34314 18 0 16.6569 0 15V3ZM2 14.5858V3.41421L7.5858 9.00001L2 14.5858ZM3.41424 16H20.5858L15 10.4142L14.1213 11.2929C12.9498 12.4645 11.0503 12.4645 9.87869 11.2929L9.00001 10.4142L3.41424 16ZM16.4142 9.00002L22 14.5858V3.41424L16.4142 9.00002ZM3.41421 2H20.5858L12.7071 9.87869C12.3166 10.2692 11.6834 10.2692 11.2929 9.87869L3.41421 2Z" fill="currentColor"/>
    </g>
    `
};
export {
  e as Mail
};
